<div>
  <div>
    <div style="display: block">
      <canvas baseChart
        [datasets]="doughnutChartDatasets"
        [labels]="doughnutChartLabels"
        [type]="doughnutChartType">
      </canvas>
    </div>
  </div>
</div>